import { Alert, AlertProps, Stack, styled } from "@mui/material";
import { InternalButtonLink } from "../InternalButtonLink";
import { InternalLink } from "../InternalLink";
import { toPx } from "../MuiHelpers";
import { MuiImage } from "../MuiImage";

const CONTAINER_MAX_WIDTH_PX = 700;

export const AlertInfo = styled((props: AlertProps) => <Alert elevation={4} {...props} />)(({ theme }) =>
    theme.unstable_sx({
        my: theme.spacing(4),
    }),
);

export const BankIdButton = styled(InternalButtonLink)(({ theme }) =>
    theme.unstable_sx({
        alignSelf: "center",
        display: "flex",
        gap: theme.spacing(3),
        color: theme.palette.common.white,
        background: theme.palette.common.black,
        width: "100%",
        "&:hover": {
            backgroundColor: theme.palette.common.black,
        },
        "&:focus": {
            outlineColor: theme.palette.primary.light,
        },
    }),
);

export const BankIdLogo = styled(MuiImage)(({ theme }) =>
    theme.unstable_sx({
        height: toPx(30),
        width: "auto",
    }),
);

export const ContainerStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        maxWidth: toPx(CONTAINER_MAX_WIDTH_PX),
        margin: "0 auto",
        pt: theme.spacing(6),
    }),
);

export const RejectLink = styled(InternalLink)(({ theme }) =>
    theme.unstable_sx({
        textDecoration: "underline",
        cursor: "pointer",
    }),
);
